import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/PublicPatientScanner.jsx");
